import { CanvasEvent } from 'src/app/events/canvas.event';
import { environment } from 'src/environments/environment';

export class ContextData {

  static DPI:number = 300;

  static MM_TO_PIXELS:number;
  static PIXELS_TO_MM:number;
  static POINTS_TO_PIXELS:number;
  static PIXELS_TO_POINTS:number;
  static CONVERT_72_TO_DPI:number;
  static CONVERT_300_TO_DPI:number;
  static ZOOM_FACTOR:number = 1.5;

  static LOGO_PATH:string = environment.LOGO.LABEL;
  static PDF_URL:string = environment.PDF_URL;
  static LOGO_SVG:string = '';

  static UID:number;

  static MODE: string = CanvasEvent.SET_SELECT_MODE;

  /**
	 * Constructor
	 */
  constructor() {

  }

  /**
   * Cleaunup
   */
  static setDPI(value:number):void {
    this.DPI = value;
    this.MM_TO_PIXELS = this.DPI / 25.4;
    this.PIXELS_TO_MM = 1 / this.MM_TO_PIXELS;
    this.POINTS_TO_PIXELS = this.DPI / 72;
    this.PIXELS_TO_POINTS = 1 / this.POINTS_TO_PIXELS;
    this.CONVERT_72_TO_DPI = this.DPI / 72;
    this.CONVERT_300_TO_DPI = this.DPI / 300;
  }

  static initLogo():Promise<void> {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest;
      xhr.open('GET', environment.ASSETS_SERVER + this.LOGO_PATH);
      xhr.responseType = 'text';
      xhr.overrideMimeType('text/xml');
      xhr.onload = () => {
        if (xhr.readyState === xhr.DONE) {
          if (xhr.status === 200) {
            this.LOGO_SVG = xhr.responseText;
            resolve();
          } else {
            reject();
          }
        }
      };
      xhr.send();
    })
  }

}
